import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../utils/constants";
import editImage from "../../assets/images/icons/edit-2.svg";

const normalizeQuestionList = (data) => {
  if (!data) return [];
  if (Array.isArray(data.questions)) return data.questions;
  if (Array.isArray(data.questionList)) return data.questionList;
  if (Array.isArray(data.surveyQuestions)) return data.surveyQuestions;
  if (Array.isArray(data.data)) return data.data;
  if (Array.isArray(data)) return data;
  return [];
};

function SurveyQuestionManagement() {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);

  // const getQuestions = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const params = new URLSearchParams({
  //       page: currentPage,
  //       limit: 10,
  //     });
  //     if (searchTerm) {
  //       params.append("search", searchTerm);
  //     }

  //     const response = await handleApiCall("get", `${endpoints.surveyQuestionList}?${params.toString()}`);
  //     if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.success || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
  //       const responseData = response?.data?.data || response?.data;
  //       setQuestions(normalizeQuestionList(responseData));
  //       setTotalPages(responseData?.pagination?.totalPages || responseData?.totalPages || 1);
  //     } else if (response?.error) {
  //       console.error("Error fetching survey questions:", response?.message);
  //       setQuestions([]);
  //     } else {
  //       setQuestions([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching survey questions:", error);
  //     setQuestions([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [currentPage, searchTerm]);

  // useEffect(() => {
  //   getQuestions();
  // }, [getQuestions]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // const handleStatusToggle = async (questionId, currentStatus) => {
  //   try {
  //     const newStatus = currentStatus === 1 ? 0 : 1;
  //     setStatusUpdatingId(questionId);

  //     const response = await handleApiCall("patch", `${endpoints.updateSurveyQuestionStatus}/${questionId}`, {
  //       status: newStatus,
  //     });

  //     if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
  //       toast.success("Survey question status updated successfully!");
  //       getQuestions();
  //     } else if (response?.error) {
  //       console.error("Error updating survey question status:", response?.message);
  //     }
  //   } catch (error) {
  //     console.error("Error updating survey question status:", error);
  //   } finally {
  //     setStatusUpdatingId(null);
  //   }
  // };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Survey Question Management</h3>
              <Link to="/add-survey-question" className="btn btn-primary rounded-2 px-3 ml-auto">
                {UI_CONSTANTS.BUTTON_LABELS.CREATE_NEW} <span className="ml-2">+</span>
              </Link>
            </div>

            {/* <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control search-icon left-icon border"
                    placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div> */}

            <div className="table-responsive px-0">
              <table className="table table-striped trim">
                <thead>
                  <tr>
                    <th width="80">{UI_CONSTANTS.TABLE_HEADERS.SR_NO || "Sr. No."}</th>
                    <th>Question</th>
                    <th width="150">Type</th>
                    <th width="120">{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                    <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                        </div>
                      </td>
                    </tr>
                  ) : !Array.isArray(questions) || questions.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                      </td>
                    </tr>
                  ) : (
                    questions.map((question, index) => {
                      const questionId = question._id || question.id || `survey-question-${index}`;
                      const questionText = question.question_en || question.question || question.title || "";
                      const type = question.type || question.question_type || "-";
                      const status = question.status ?? 0;

                      return (
                        <tr key={questionId}>
                          <td>{(currentPage - 1) * 10 + index + 1}</td>
                          <td>{questionText || UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}</td>
                          <td className="text-capitalize">{type}</td>
                          <td>
                            <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                checked={status === 1}
                                onChange={() => {}}
                                disabled={statusUpdatingId === questionId}
                              />
                              <span className="custom-control-label custom-toggle" />
                            </label>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              <Link to={`/edit-survey-question/${questionId}`} state={{ surveyQuestion: question }} className="btn btn-link p-0 mx-2">
                                <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        {UI_CONSTANTS.BUTTON_LABELS.PREVIOUS || "Previous"}
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        {UI_CONSTANTS.BUTTON_LABELS.NEXT || "Next"}
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SurveyQuestionManagement;

